import React, { type ButtonHTMLAttributes, type Ref } from "react";

type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";
type ButtonSize = "sm" | "md";

interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "size"> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  ref?: Ref<HTMLButtonElement>;
}

const SIZE_CLASSES: Record<ButtonSize, string> = {
  sm: "px-3 py-1.5 text-xs",
  md: "px-4 py-2.5 text-sm",
};

const VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary:
    "border-2 border-ink bg-ink text-canvas hover:bg-canvas hover:text-ink disabled:opacity-40 disabled:hover:bg-ink disabled:hover:text-canvas",
  secondary:
    "border-2 border-ink bg-canvas text-ink hover:bg-ink hover:text-canvas disabled:opacity-40 disabled:hover:bg-canvas disabled:hover:text-ink",
  ghost:
    "border-2 border-faint bg-canvas text-muted hover:border-ink hover:text-ink disabled:opacity-40",
  danger:
    "border-2 border-ink bg-canvas text-ink hover:border-accent hover:bg-accent hover:text-canvas disabled:opacity-40",
};

export function Button({
  variant = "primary",
  size = "md",
  className,
  type = "button",
  disabled,
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={[
        "inline-flex items-center justify-center font-mono font-medium uppercase tracking-wider",
        "transition-none cursor-pointer disabled:cursor-not-allowed",
        SIZE_CLASSES[size],
        VARIANT_CLASSES[variant],
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      {...rest}
    />
  );
}
